import React, { Component } from "react"
import ReactQuill from "react-quill"
import { Input, Button } from "antd"
import threePointsGray from "../../images/three-points-gray-config.svg"
import configBackground from "../../images/config-background.svg"
import "react-quill/dist/quill.snow.css"
import { woopraTrack } from "../../utils/woopra/woopraTracker"

const Editor = {
  modules: {
    toolbar: [
      [{ header: [1, 2, false] }],
      [
        "bold",
        "italic",
        "underline",
        {
          color: [
            "#000000",
            "#e60000",
            "#ff9900",
            "#ffff00",
            "#008a00",
            "#0066cc",
            "#9933ff",
            "#ffffff",
            "#facccc",
            "#ffebcc",
            "#ffffcc",
            "#cce8cc",
            "#cce0f5",
            "#ebd6ff",
            "#bbbbbb",
            "#f06666",
            "#ffc266",
            "#ffff66",
            "#66b966",
            "#66a3e0",
            "#c285ff",
            "#888888",
            "#a10000",
            "#b26b00",
            "#b2b200",
            "#006100",
            "#0047b2",
            "#6b24b2",
            "#444444",
            "#5c0000",
            "#663d00",
            "#666600",
            "#003700",
            "#002966",
            "#3d1466",
          ],
        },
        { align: ["center", "right", "justify"] },
      ],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
    ],
  },
  formats: [
    "header",
    "bold",
    "italic",
    "underline",
    "list",
    "color",
    "align",
    "bullet",
    "indent",
  ],
}

class firstStepConfig extends Component {
  reactStartQuillRef = React.createRef()
  reactEndQuillRef = React.createRef()
  state = {
    disableMessageStart: false,
    disableMessageEnd: false,
  }

  hideFooter = () => {
    const { configSurvey } = this.props

    return (
      this.props.title === configSurvey.title &&
      this.props.message_start.replace(/ +?/g, "") ===
        configSurvey.message_start.replace(/ +?/g, "") &&
      this.props.button_start_text === configSurvey.button_start_text &&
      this.props.message_end === configSurvey.message_end &&
      this.props.button_end_text === configSurvey.button_end_text
    )
  }

  render() {
    return (
      <div className="first-step-container">
        <div>
          <div className="first-step-container-title">MENSAJES</div>
          <div className="first-step-container-item first-step-container-item-horizontal border-gray-bottom">
            <span>Título</span>
            <Input
              maxLength={100}
              value={this.props.title}
              onChange={(e) => this.props.setStateFrom("title", e.target.value)}
            />
          </div>
          <div className="first-step-container-item first-step-container-item-vertical">
            <div
              style={{
                marginBottom: 16,
                display: "flex",
                justifyContent: "space-between",
              }}>
              <span>Mensaje de bienvenida</span>
              {this.state.disableMessageStart && (
                <span
                  style={{
                    color: "rgb(210, 108, 108)",
                    fontSize: 12,
                  }}>
                  Máximo 500 caracteres
                </span>
              )}
            </div>
            <ReactQuill
              ref={this.reactStartQuillRef}
              modules={Editor.modules}
              formats={Editor.formats}
              className="measurement-mail-configuration-text survey-config-quill"
              value={this.props.message_start}
              onChange={(e) => {
                this.props.setStateFrom("message_start", e)
                if (this.reactStartQuillRef.current) {
                  if (
                    this.reactStartQuillRef.current
                      .getEditor()
                      .getText()
                      .trim().length > 500
                  ) {
                    this.setState({ disableMessageStart: true })
                  } else {
                    this.setState({ disableMessageStart: false })
                  }
                }
              }}
            />
          </div>
          <div className="first-step-container-item first-step-container-item-horizontal border-gray-bottom">
            <span>Botón de inicio</span>
            <Input
              maxLength={24}
              value={this.props.button_start_text}
              onChange={(e) =>
                this.props.setStateFrom("button_start_text", e.target.value)
              }
            />
          </div>
          <div className="first-step-container-item first-step-container-item-vertical">
            <div
              style={{
                marginBottom: 16,
                display: "flex",
                justifyContent: "space-between",
              }}>
              <span>Mensaje Final</span>
              {this.state.disableMessageEnd && (
                <span
                  style={{
                    color: "rgb(210, 108, 108)",
                    fontSize: 12,
                  }}>
                  Máximo 500 caracteres
                </span>
              )}
            </div>
            <ReactQuill
              ref={this.reactEndQuillRef}
              modules={Editor.modules}
              formats={Editor.formats}
              spellcheck="false"
              className="measurement-mail-configuration-text survey-config-quill"
              value={this.props.message_end}
              onChange={(e) => {
                this.props.setStateFrom("message_end", e)
                if (
                  this.reactEndQuillRef.current
                    .getEditor()
                    .getText()
                    .trim().length > 500
                ) {
                  this.setState({ disableMessageEnd: true })
                } else {
                  this.setState({ disableMessageEnd: false })
                }
              }}
            />
          </div>
          <div className="first-step-container-item first-step-container-item-horizontal border-gray-bottom">
            <span>Botón final</span>
            <Input
              maxLength={24}
              value={this.props.button_end_text}
              onChange={(e) =>
                this.props.setStateFrom("button_end_text", e.target.value)
              }
            />
          </div>
          {!this.hideFooter() && (
            <div className="footer-survey-config">
              <Button onClick={this.props.updateAllState}>Cancelar</Button>
              <Button
                disabled={
                  !this.props.title ||
                  !this.props.message_start ||
                  !this.props.message_end ||
                  !this.props.button_end_text ||
                  !this.props.button_start_text ||
                  this.state.disableMessageStart ||
                  this.state.disableMessageEnd
                }
                type="primary"
                onClick={() => {
                  woopraTrack("Guardar configuración de mensaje cuestionario")
                  const {
                    title,
                    message_start,
                    message_end,
                    button_start_text,
                    button_end_text,
                  } = this.props

                  const params = {
                    idSurvey: this.props.id_survey,
                    editSettingSegment: this.props.editSettingSegment,
                    params: {
                      title,
                      message_start,
                      message_end,
                      button_start_text,
                      button_end_text,
                    },
                  }

                  this.props.updateConfigSurveyWatcher(params)
                }}>
                Guardar
              </Button>
            </div>
          )}
        </div>

        <div
          className="survey-config-view"
          style={{
            position: "relative",
            backgroundColor: this.props.background_color,
          }}>
          <div className="survey-config-view-top" style={{ zIndex: 1 }}>
            <span
              className="survey-config-view-title"
              style={{ color: this.props.color_button }}>
              {this.props.title}
            </span>
            <div
              className="ql-editor measurement-mail-configuration-content-text"
              dangerouslySetInnerHTML={{ __html: this.props.message_start }}
            />
            <Button
              type="primary"
              size="large"
              style={{
                backgroundColor: this.props.color_button,
                border: "none",
              }}>
              {this.props.button_start_text}
            </Button>
          </div>
          <div className="survey-config-view-points">
            <img src={threePointsGray} />
          </div>
          <div className="survey-config-view-top" style={{ zIndex: 1 }}>
            <div
              className="ql-editor measurement-mail-configuration-content-text"
              dangerouslySetInnerHTML={{ __html: this.props.message_end }}
            />
            <Button
              type="primary"
              size="large"
              style={{
                backgroundColor: this.props.color_button,
                border: "none",
              }}>
              {this.props.button_end_text}
            </Button>
          </div>
          <div className="logo-top-right">
            <img
              src={this.props.company_logo}
              style={{ opacity: this.props.company_logo_opacity / 100 }}
            />
          </div>
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              backgroundSize: "cover",
              backgroundPosition: "center 0px",
              left: 0,
              top: 0,
              backgroundColor: "#FFF",
              backgroundImage: `url(${this.props.background_image})`,
              opacity: this.props.background_image_opacity / 100,
            }}
          />
        </div>
      </div>
    )
  }
}

export default firstStepConfig
